import React, {Fragment, useMemo, useState} from 'react';
import User from '../../models/User'
import ProjectGroup from '../../models/ProjectGroup';
import {CheckBox} from '../../components/form/CheckboxInput';
import {useAuth} from "../../providers/AuthProvider";
import {useOutletContext, useParams} from "react-router-dom";

const ManageProjectGroup = (props) => {

    const {
        groups,
        disabled,
        createOrUpdateGroup,
    } = useOutletContext();

    const params = useParams()
    const group = useMemo(() => {
        if(!groups?.length || !params?.groupId) return;

        return TB.find(groups, ['id', parseInt(params?.groupId)])
    }, [groups, params]);

    const [groupMembers, setGroupMembers] = useState(group.members);

    const {auth} = useAuth();

    const updatePermissionValue = (memberId, checkboxData) => {
        if (!auth.canEditGroupPermissions()) return TB.showPermissionError();
        const groupMembersCopy = TB.map([...groupMembers], member => {

            if (member.id === memberId) {

                let permissions = TB.set(member.permissions, checkboxData.name, checkboxData.checked);

                let groupOfChangedPermission = TB.find(TB.values(ProjectGroup.GroupedPermissions), group => TB.values(group)
                    .includes(checkboxData.name));

                let canViewGroupPermission = TB.find(groupOfChangedPermission, perm => perm.includes('can_view'))

                // Reset group permissions if GroupCanViewPermission is false
                if (checkboxData.name.includes('can_view') && !checkboxData.checked) {

                    TB.map(groupOfChangedPermission, perm => {
                        permissions = TB.set(permissions, perm, false);
                    })

                } else if (checkboxData.checked && !permissions[canViewGroupPermission]) {
                    // Set GroupCanViewPermission to true if another permission in group is toggled on
                    permissions = TB.set(permissions, canViewGroupPermission, true)
                }

                return User.make({
                        ...member,
                        permissions
                    }
                );
            }
            return member;
        })

        return setGroupMembers(groupMembersCopy)
    }

    const acceptsStandardSOW = auth.clientOrg?.()?.acceptsStandardSOW();
    return (
        <div className="manage-project-group-container">
            {!auth.canEditGroupPermissions() && (
                <div className="permission-error-box">
                    <p>
                        You do not have access to manage permissions for this group. Please contact your administrator
                        or Wripple client lead for more information.
                    </p>
                </div>
            )}


            <div className="manage-content">
                <p className="my-5 text-base">
                    View & manage group member permissions
                </p>
                <div className="bg-white p-3 overflow-scroll">
                    <table className="table group-permission-table table-auto" style={{maxWidth: 'unset'}}>
                        <thead>
                        <tr>
                            <th colSpan={1}/>

                            {TB.keys(ProjectGroup.GroupedPermissions).map((groupLabel, index) => (
                                <Fragment key={groupLabel}>
                                    <th
                                        className={TB.mapClass("border-b-0 text-center border border-gray-300", {
                                            'table-dark': index !== 1,
                                            'table-default': index === 1
                                        })}
                                        colSpan={TB.keys(ProjectGroup.GroupedPermissions[groupLabel]).length}>
                                        {groupLabel}
                                    </th>
                                </Fragment>
                            ))}
                        </tr>
                        <tr>
                            <th>User</th>

                            {TB.map(TB.values(ProjectGroup.GroupedPermissions), (permissions, groupIndex) => (
                                <Fragment key={`permissions-${groupIndex}`}>
                                    {TB.map(TB.keys(permissions), (name, index) => {
                                        if (permissions[name] === 'can_edit_sow' && !acceptsStandardSOW) {
                                            return null
                                        }
                                        return (
                                            <th key={name} style={{width: '9%'}} className={groupIndex !== 1 ? 'table-dark border border-gray-300' : 'table-default border border-gray-300'}>
                                                <p className={index === 0 ? 'text-secondary' : ''}>
                                                    {name}
                                                </p>
                                            </th>
                                        )
                                    })}
                                </Fragment>
                            ))}

                        </tr>
                        </thead>

                        <tbody>
                        {groupMembers.map(member => {

                            return (
                                <tr key={member.id}>
                                    <td className="border border-gray-300">
                                        <div className="member-name"
                                             title={member.isClientAdmin() ? "Group Admin" : undefined}>

                                            <p>
                                                {member.isClientAdmin() && (
                                                    <i className="fas fa-key" style={member.isClientSuperAdmin() ?  {color: '#daa520'} : undefined}/>
                                                )}
                                                {member.fullName()}
                                            </p>
                                        </div>
                                    </td>

                                    {TB.map(TB.values(ProjectGroup.GroupedPermissions), (permissions, groupIndex) => (
                                        <Fragment key={`permissions-${groupIndex}`}>
                                            {TB.map(TB.keys(permissions), (name, index) => {
                                                const key = permissions[name]
                                                if (key === 'can_edit_sow' && !acceptsStandardSOW) {
                                                    return null
                                                }
                                                return (
                                                    <td key={key}
                                                        className={groupIndex !== 1 ? 'table-dark border border-gray-300' : 'table-default border border-gray-300'}>
                                                        <CheckBox
                                                            checkboxClass={index === 0 ? 'visibility-checkbox': ''}
                                                            name={key}
                                                            disabled={disabled || !auth.canEditGroupPermissions() || !auth.canEditUserGroupPermissions(member)}
                                                            value={member.permissions[key]}
                                                            setValue={checkboxData => updatePermissionValue(member.id, checkboxData)}
                                                        />
                                                    </td>
                                                )
                                            })}
                                        </Fragment>
                                    ))}

                                    {/*<td className="remove-member">*/}

                                    {/*    {auth.canRemoveUserToGroup(member) && (*/}
                                    {/*        <button className="btn btn-icon" onClick={() => {*/}
                                    {/*            */}
                                    {/*        }}>*/}
                                    {/*            <i className="fas fa-trash"/>*/}
                                    {/*        </button>*/}
                                    {/*    )}*/}
                                    {/*</td>*/}
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                </div>

                {auth?.canManageGroups() && (
                    <div className="pt-4 flex justify-end">
                        <button className="btn btn-primary"
                                disabled={disabled || TB.isEqual(group.members, groupMembers)}
                                onClick={() => {
                                    return createOrUpdateGroup(ProjectGroup.make({...group, members: groupMembers}))
                                }}>
                            Save
                        </button>
                    </div>
                )}
            </div>

        </div>
    );
};

export default ManageProjectGroup;